export default "__VITE_ASSET__311106a6__"